import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)<{ $marketplaceEnabled?: boolean }>`
    display: flex;
    width: 23px;
    height: 23px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    position: absolute;
    top: 8px;
    left: 8px;

    img {
        width: 100%;
    }

    ${({ $marketplaceEnabled }) =>
        !$marketplaceEnabled &&
        css`
            top: 10px;
            left: 8px;
        `}
`;
